module.exports = __webpack_public_path__ + "media/images/icon_favorite-2d82e9d3ca964a302c5f38a0260c8ef2.svg";